import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedbackRequest } from '../../models';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import {
  FeedbackRequestsActions,
  FeedbackRequestsSelectors
} from '../../store';
import { PageEvent } from '@angular/material/paginator';
import { StringsUtility } from '../../../shared/utilities/strings.utility';
import { RouterActions } from '../../../application-state/store/actions';

@Component({
  selector: 'app-feedback-gotten-widget',
  templateUrl: './feedback-gotten-widget.component.html',
  styleUrls: ['./feedback-gotten-widget.component.scss']
})
export class FeedbackGottenWidgetComponent implements OnInit {
  lowValue = 0;
  highValue = 5;
  isLoading$: Observable<boolean>;
  feedbacks$: Observable<FeedbackRequest[]>;

  constructor(private store$: Store<ApplicationState>) {}

  ngOnInit(): void {
    this.isLoading$ = this.store$.pipe(
      select(FeedbackRequestsSelectors.isLoading)
    );
    this.feedbacks$ = this.store$.select(
      FeedbackRequestsSelectors.selectFeedbackRequests
    );
    this.loadData();
  }

  loadData(): void {
    this.store$.dispatch(FeedbackRequestsActions.LoadFeedbackRequests());
  }

  handleUpdatePageOrSize(event: PageEvent): void {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
  }

  handleClick($event): void {
    const iri = $event.relatedInstance;
    const type: string = iri.split('/')[2];
    const uuid = iri.startsWith('/') ? StringsUtility.getUuidFromIri(iri) : iri;
    const uuidCustomerComment = $event.commentIri.startsWith('/')
      ? StringsUtility.getUuidFromIri($event.commentIri)
      : $event.commentIri;
    this.store$.dispatch(
      RouterActions.Go({
        path: [type, uuid],
        query: { target_comment: uuidCustomerComment }
      })
    );
  }
}
